module.exports = {"130110100":"获鹿镇","130110101":"铜冶镇","130110102":"寺家庄镇","130110103":"上庄镇","130110104":"李村镇","130110105":"宜安镇","130110106":"黄壁庄镇","130110107":"大河镇","130110108":"山尹村镇","130110200":"石井乡","130110201":"白鹿泉乡","130110202":"上寨乡","130110500":"河北鹿泉经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130110.json
// module id = 63
// module chunks = 0